import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
export const usePhotoDelete = clubSlug => {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== clubSlug || $[1] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: _data => {
        queryClient.invalidateQueries({
          queryKey: ["club", clubSlug, "photos"]
        });
      }
    };
    $[0] = clubSlug;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useMutation(t0);
};
async function _temp(id) {
  const response = await fetch("/api/club-photos", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id
    })
  });
  if (!response.ok) {
    throw new Error(`Erreur ${response.status}: ${response.statusText}`);
  }
  const data = await response.json();
  return data;
}